<template>
  <div class="container" v-if="isShow" >
    <div class="step-one" v-if="step == 1">
      <img src="@/assets/images/mkk_logo.png" class="logo-img" />
      <div class="logo">Mari bergabung dengan MAKUKU Community!<br/>Yuk, daftar dengan mengisi data di bawah ini.</div>
      <div class="mobile">
        <div class="title">Nomor WhatsApp (Handphone) Moms/Dads</div>
        <div class="value">
          <span class="prefix">{{ number_prefix }}</span>
          <mt-field class="row phone" placeholder="8xx-xxxx-xxxx" v-model="form.mobile"></mt-field>
        </div>
      </div>
      <div class="protocol">
        <div class="iconfont" @click="isAgree = !isAgree" :class="isAgree ? 'icon-check' : 'icon-no-check'" ></div>
        <div class="text">Saya telah membaca dan menyetujui <span @click="openAgree()" >Pernyataan, Syarat dan Ketentuan</span> dan <span @click="openAgree()" >Cookie</span></div>
      </div>
      <div class="opt">
        <!--<div class="title">OTP</div>-->
        <div class="send-code-but" :class="isCounting ? 'disabled' : ''" id="captcha-button" >
          {{ isCounting ? `Coba lagi setelah ${ countdown} detik` : 'Kirim Kode OTP' }}
        </div>
        <div class="tip">Masukkan Kode OTP</div>
        <div class="opt-number">
          <VerificationCodeInput v-model="form.code" :length="6" />
        </div>
        <!--<div class="value">-->
        <!--  <mt-field class="row" placeholder="Silakan masukkan kode verifikasi" v-model="form.code">-->
        <!--    &lt;!&ndash;<span class="send-code" id="captcha-button" >{{ isCounting ? `Coba lagi setelah ${ countdown} detik` : 'Mengirim' }}</span>&ndash;&gt;-->
        <!--  </mt-field>-->
        <!--</div>-->
      </div>

      <div class="login-but" @click="next()">MASUK</div>
      <div class="ad">
        <img @click="openDetail()" src="https://sgp-cdn.makuku.com/makuku_web_cdn/assets/crm/ad.jpg" alt="">
      </div>
    </div>

    <div class="step-two" v-else-if="step == 2">
      <img src="@/assets/images/mkk_logo.png" class="logo-img" />
      <div class="form">
        <div class="block">
          <div class="field-title">Nama Mom / Dad</div>
          <mt-field class="row" v-model="form.name" placeholder="Silakan masukkan nama ibu"></mt-field>
          <div class="field-title">
            <span>Jumlah Anak</span>
            <span class="subtitle">*dibawah 3 tahun</span>
          </div>
          <div class="son_number">
            <span @click="subtraction()">-</span>
            <!--<input type="number" v-model="form.son_number" disabled>-->
            <span class="number">{{ form.son_number }}</span>
            <span @click="addition()">+</span>
          </div>
          <template v-for="(value, index) in form.ages">
            <div class="field-title">Tanggal Lahir Anak {{ index + 1 }}</div>
            <div class="date-input" :class="{ default: value == '' }" @click="openPicker(index)" > {{ value ? value : '12/02/2020' }}  </div>
          </template>
          <!--<div class="age" v-for="(value, index) in form.ages">-->
          <!--  <div class="title">Usia bayi</div>-->
          <!--  <div class="value" @click="openSelectAge(index, value)">{{ value }}</div>-->
          <!--  <div class="iconfont icon-right" @click="openSelectAge(index, value)"></div>-->
          <!--</div>-->
        </div>
        <div class="block">
          <div class="title">Produk paling sering digunakan saat ini :</div>
          <div class="subtitle">*maksimal 3 produk</div>
          <mt-checklist
            class="row"
            :max="3"
            v-model="form.product"
            @change="handleChange"
            :options="product">
          </mt-checklist>
          <mt-field class="diy-product" v-if="form.product.includes('Lainnya')" v-model="form.diy_product" placeholder="Silakan masukkan nama produk"></mt-field>
        </div>
        <div class="block">
          <div class="title">Ukuran Popok yang digunakan saat ini :</div>
          <mt-radio
            class="row"
            v-model="form.size"
            :options="size">
          </mt-radio>
        </div>
      </div>
      <div class="submit" @click="submit()" >Submit</div>
    </div>
    <div class="step-three" v-else-if="step == 3" >
      <div class="panel">
        <div class="iconfont icon-radio1"></div>
        <div class="tip">Terima kasih banyak atas partisipasinya</div>
      </div>
      <div class="ad">
        <img @click="openDetail()" src="https://sgp-cdn.makuku.com/makuku_web_cdn/assets/crm/ad_2.jpg" alt="">
      </div>
    </div>
    <!-- 选择月份 -->
    <mt-popup
      v-model="popupVisible"
      class="month-popup"
      position="bottom">
      <mt-picker v-if="popupVisible" :slots="slots" value-key="label" @change="onValuesChange" :showToolbar="true">
        <div class="toolbar">
          <span @click="cancel()">Membatalkan</span>
          <span @click="confirm()">Mengonfirmasi</span>
        </div>
      </mt-picker>
    </mt-popup>
    <div id="captcha-element"></div>
    <!-- 选择日期 -->
    <mt-datetime-picker
      ref="picker"
      type="date"
      :startDate="new Date('2020/1/1')"
      :endDate="new Date()"
      cancelText="Batal"
      confirmText="Konfirmasi"
      @confirm="handleConfirm"
      v-model="pickerValue">
    </mt-datetime-picker>
    <!-- 显示已注册过信息 -->
    <mt-popup
      v-model="isRegistered"
      class="tip-content"
      >
      <img src="@/assets/images/mkk_logo.png" class="logo" />
      <div class="title">
        <img src="@/assets/images/warn.png" class="warn" />
        <span>SUDAH PERNAH TERDAFTAR</span>
        <img src="@/assets/images/warn.png" class="warn" />
      </div>
      <div class="desc">Terima kasih atas permintaan sample Moms/Dads
        Mohon maaf, dikarenakan Moms/Dads sudah terdaftar
        sebelumnya, untuk sample tidak dapat kami berikan.
        Tunggu program seru lainnya dari kami, ya!</div>
      <div class="confirm-but" @click="isRegistered = fasle" >Baik, Saya Mengerti</div>
    </mt-popup>

    <!-- 显示协议 -->
    <mt-popup
      v-model="isShowAgree"
      class="agree-content"
    >
      <iframe src="https://mozilla.github.io/pdf.js/web/viewer.html?file=https://sgp-cdn.makuku.com/makuku_web_cdn/assets/crm/protocol.pdf"></iframe>
      <div class="confirm-but" @click="isShowAgree = fasle" >Baik, Saya Mengerti</div>
    </mt-popup>
  </div>
</template>

<script>

window.AliyunCaptchaConfig = {
  // 必填，验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
  region: "sgp",
  // 必填，身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
  prefix: "1q91i0",
};

import { isNotEmpty, parseTime } from '@/lib/util';
import { checkActivityValid, sendCodeToWhatsApp, submitMonInformation, verifyCodeApi } from "@/api/crm/register";
import "@/assets/js/aliyunCaptcha/AliyunCaptcha.js";
import VerificationCodeInput from '@/components/VerificationCodeInput.vue';

export default {
  components: {
    VerificationCodeInput
  },
  data () {
    return {
      step: 1, // 步骤
      form: {
        mobile: "",
        name: '',
        son_number: 1,
        product: [],
        size: '',
        code: '',
        ages: [''],
        diy_product: "", // 自定义其他名称
      },
      product: [
        {
          label: 'MAKUKU SLIM',
          value: 'MAKUKU SLIM',
          disabled: false
        },
        {
          label: 'MAKUKU COMFORT FIT',
          value: 'MAKUKU COMFORT FIT',
          disabled: false
        },
        {
          label: 'MAKUKU DRY CARE',
          value: 'MAKUKU DRY CARE',
          disabled: false
        },
        {
          label: 'MAMYPOKO ROYAL SOFT',
          value: 'MAMYPOKO ROYAL SOFT',
          disabled: false
        },
        {
          label: 'MAMYPOKO X-TRA KERING',
          value: 'MAMYPOKO X-TRA KERING',
          disabled: false
        },
        {
          label: 'SWEETY CLOUD SOFT',
          value: 'SWEETY CLOUD SOFT',
          disabled: false
        },
        {
          label: 'SWEETY DRY X-PERT',
          value: 'SWEETY DRY X-PERT',
          disabled: false
        },
        {
          label: 'MERRIES SKIN PROTECTION',
          value: 'MERRIES SKIN PROTECTION',
          disabled: false
        },
        {
          label: 'MERRIES GOOD SKIN',
          value: 'MERRIES GOOD SKIN',
          disabled: false
        },
        {
          label: 'BABY HAPPY',
          value: 'BABY HAPPY',
          disabled: false
        },
        {
          label: 'Lainnya',
          value: 'Lainnya',
          disabled: false
        }
      ],
      size: [
        'NB',
        'S',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL'
      ],
      popupVisible: false,
      slots: [
        {
          flex: 1,
          values: [],
          defaultIndex: 0
        }
      ],
      selectValue: "", // 选择的值
      currentIndex: 0, // 当前选中的索引
      isCounting: false, // 是否正在倒计时
      countdown: 60, // 倒计时秒数
      timer: null, // 定时器
      isShow: false,
      captchaButton: null, // 图形验证触发按钮
      captcha: null, // 图形验证码实例
      isAgree: false, // 是否同意协议
      number_prefix: "+62", // 号码前缀
      pickerValue: "",
      isRegistered: false, // 是否显示提示已经注册过
      isShowAgree: false, // 显示协议
     };
  },
  beforeDestroy () {
    // 组件销毁前清除定时器，防止内存泄漏
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.captchaButton = null;
    // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
    document.getElementById('aliyunCaptcha-mask')?.remove();
    document.getElementById('aliyunCaptcha-window-popup')?.remove();
  },
  methods: {
    openDetail() {
      // window.open("");
      location.href = "https://makuku.co.id/id/skin-health?utm_source=spg&utm_medium=spg&utm_campaign=Offline_SPG";
    },
    // 打开协议内容
    openAgree() {
      this.isShowAgree = true;
    },
    handleConfirm() {
      // this.form.ages[this.currentIndex] = parseTime(this.pickerValue, '{y}/{m}/{d}');
      if(isNotEmpty(this.pickerValue)){
        this.$set(this.form.ages, this.currentIndex, parseTime(this.pickerValue, '{m}/{d}/{y}'));
      } else {
        this.$set(this.form.ages, this.currentIndex, '');
      }

    },
    // 打开选择日期
    openPicker(index) {
      this.currentIndex = index;
      this.$refs.picker.open();
    },
    getInstance(instance) {
      this.captcha = instance;
    },
    // 验证通过后调用
    onBizResultCallback() {
      console.log('onBizResultCallback');
    },
    // 初始化阿里云图片验证
    initCaptcha() {
      this.captchaButton = document.getElementById('captcha-button');
      window.initAliyunCaptcha({
        SceneId: '111k0fag', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: '1q91i0', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: '#captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        captchaVerifyCallback: this.sendCode, // 业务请求(带验证码校验)回调函数，无需修改
        onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
        getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: 360,
          height: 40,
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: 'in', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      });
    },
    handleChange() {
      if (this.form.product.length === 3) {
        this.product.forEach((item, i) => {
          if (!this.form.product.includes(item.value)) {
            item.disabled = true;
          }
        })
      } else if(this.form.product.length == 2) {
        this.product.forEach((item, i) => {
          item.disabled = false;
        })
      }
    },
    openSelectAge (index, value) {
      if (isNotEmpty(value)) {
        this.slots[0].values.forEach((item, i) => {
          if (item.value == value) {
            this.slots[0].defaultIndex = i;
          }
        })
      }
      this.currentIndex = index;
      this.popupVisible = true;
    },
    cancel () {
      this.popupVisible = false;
    },
    confirm () {
      this.form.ages[this.currentIndex] = this.selectValue;
      this.popupVisible = false;
    },
    onValuesChange (picker, values) {
      this.selectValue = values[0].value;
    },
    // 校验验证码有效性
    verifyCode () {
      if (!isNotEmpty(this.form.mobile)) {
        this.$toast("Silakan isi nomor ponsel Anda");
        return;
      }
      if (!isNotEmpty(this.form.code)) {
        this.$toast("Silakan isi kode verifikasi");
        return;
      }
      if (!this.isAgree) {
        this.$toast("Mohon untuk menyetujui perjanjiannya terlebih dahulu");
        return;
      }
      verifyCodeApi(this.number_prefix + this.form.mobile, this.form.code).then(({ data }) => {
        if (data.flag) {
          this.step = 2;
        } else if(data.message == 'Nomor ini sudah terdaftar, Tunggu program kami selanjutnya.') {
          // this.step = 3;
          this.isRegistered = true;
          setTimeout(() => {
            this.openDetail();
          }, 10000);
          return;
        } else {
          this.$toast(data.message);
        }
      })
    },
    // 提交妈妈信息
    submit () {
      let param = {
        // baby1: '', // baby1的月龄
        // baby2: '', // baby2的月龄
        // baby3: '', // baby3的月龄
        // baby4: '', // baby4的月龄
        // baby5: '', // baby5的月龄
        babySum: this.form.son_number, // 宝宝数量
        name: this.form.name, // 姓名
        phoneNumber: this.number_prefix + this.form.mobile, // 手机号
        sku1: '', // sku1
        sku2: '', // sku2
        sku3: '', // sku3
        skuSize: this.form.size, // sku size
        number: this.form.code, // 验证码
        recordId: this.$route.query.recordId,
        account: this.$route.query.account,
      };
      let product_number = 0;
      if (!isNotEmpty(this.form.name)) {
        this.$toast("Nama ibu tidak boleh kosong");
        return;
      }

      if (!isNotEmpty(this.form.ages)) {
        this.$toast("Mohon isi bulan bayinya");
        return;
      }

      let isAgeHaveEmpty = false;
      this.form.ages.forEach((v, i) => {
        if (!isNotEmpty(v)) {
          isAgeHaveEmpty = true;
        } else {
          param['baby' + (i + 1)] = v;
        }
      })
      if (isAgeHaveEmpty) {
        this.$toast("Mohon isi bulan bayinya");
        return;
      }

      this.form.product.forEach((v, i) => {
        if(v == 'Lainnya') {
          ++product_number;
          param['sku' + (i + 1)] = this.form.diy_product;
        } else if (product_number < 4) {
          ++product_number;
          param['sku' + (i + 1)] = v;
        }
      })

      if (!isNotEmpty(param['sku1']) && !isNotEmpty(param['sku2']) && !isNotEmpty(param['sku3']) ) {
        console.log("请选择使用的产品");
        this.$toast("Silakan pilih produk yang Anda gunakan");
        return;
      }

      if (!isNotEmpty(this.form.size)) {
        this.$toast("Pilih ukuran produk yang Anda inginkan");
        return;
      }
      submitMonInformation(param).then(({ data }) => {
        if (data.flag) {
          // this.$toast("提交成功");
          this.step = 3;
          setTimeout(() => {
            this.openDetail();
          }, 30000);
        } else {
          this.$toast(data.message)
        }
      })
    },
    // TODO :验证活动有效和分享者有效性
    // 发送验证码
    async sendCode (captchaVerifyParam) {
      if (this.isCounting) {
        return;
      }
      let isResult = false;
      if (isNotEmpty(this.form.mobile)) {
        if (this.isValidIndonesianPhoneNumber(this.number_prefix + this.form.mobile)) {
          await sendCodeToWhatsApp({
            captchaVerifyParam: captchaVerifyParam,
            phoneNumber: this.number_prefix + this.form.mobile
          }).then(({ data, code }) => {
            if(code == 101) {
              this.$toast('Invalid Request: This number is already registered.');
              return;
            } else if (data.flag) {
              isResult = true;
              this.$toast('Kode verifikasi telah terkirim');

              // 开始倒计时
              this.isCounting = true;
              this.timer = setInterval(() => {
                if (this.countdown > 0) {
                  this.countdown--; // 每秒减少 1 秒
                } else {
                  // 倒计时结束，清理定时器并重置状态
                  clearInterval(this.timer);
                  this.isCounting = false;
                  this.countdown = 60; // 恢复初始值
                }
              }, 1000);

            } else {
              isResult = false;
              // this.captchaButton.click();
            }
          })
          return {
            captchaResult: isResult,
            bizResult: isResult,
          };
        } else {
          this.$toast('Format nomor ponsel salah');
        }
      } else {
        this.$toast('Nomor telepon seluler tidak boleh kosong');
      }
    },
    // 印尼手机号校验
    isValidIndonesianPhoneNumber (phoneNumber) {
      if (!phoneNumber) {
        return false; // 空值直接返回 false
      }
      // 正则表达式
      const INDONESIAN_PHONE_REGEX = /^(\+62)\d{9,14}$/;
      return INDONESIAN_PHONE_REGEX.test(phoneNumber);
    },
    addition () {
      if (this.form.son_number < 3) {
        this.form.son_number++;
        this.form.ages.push('');
      }
    },
    subtraction () {
      if (this.form.son_number > 0) {
        this.form.son_number--;
        this.form.ages.pop();
      }
    },
    next () {
      this.verifyCode();
    },
    // 检测活动有效性
    checkActivity () {
      if(isNotEmpty(this.$route.query.account) && isNotEmpty(this.$route.query.recordId)){
        location.href = `https://wa.me/6281138239980?text=%23${this.$route.query.account}%23%20Kirim%20Pesan%20ini%20untuk%20mendaftar%20`;
        // checkActivityValid({
        //   account: this.$route.query.account,
        //   recordId: this.$route.query.recordId,
        // }).then(({data})=> {
        //   if (data.flag) {
        //     this.isShow = true;
        //     this.$nextTick(()=> {
        //       this.initCaptcha();
        //     })
        //   } else {
        //     this.$toast(data.message);
        //   }
        // })
      } else {
        this.$toast("Parameter hilang");
      }
    }
  },
  created () {
    window.vue = this;
    // 测试数据
    // if (this.$route.query.account == 'ID1002504007') {
    //   location.href = `https://wa.me/6281138239980?text=%23${this.$route.query.account}%23%20Kirim%20Pesan%20ini%20untuk%20mendaftar%20`;
    // } else {
      this.checkActivity();
    // }
    // 初始化可选月份
    for (let i = 1; i <= 30; i++) {
      this.slots[0].values.push({
        value: i,
        label: i + ' bulan'
      });
    }
  },
  mounted () {
  }
};
</script>

<style scoped lang="scss" >
$main_color: #DE2726;
.container {
  font-size: 16px;
  min-height: 100vh;
  //background: linear-gradient(135deg, #e9d2e9, #d5ecf7);

  ::v-deep .mint-field-core {
    //line-height: initial;
    font-family: "Microsoft YaHei";
    height: 28px;
    line-height: 28px;
  }

  ::v-deep .mint-cell-wrapper {
    background-image: none;
  }

  .form {
    ::v-deep .mint-cell-wrapper {
      flex-wrap: wrap;
      .mint-cell-title {
        width: initial;
      }

      .mint-cell-value {
        border-bottom: 1px solid #eaeaea;
      }
    }

    .son_number {
      display: flex;
      align-items: center;
      background-color: #fff;
      height: 28px;
      padding: 0 16px;
      border-radius: 7px;
      width: 83px;
      .number {
        flex-grow: 1;
        text-align: center;
        font-size: 13px;
        color: #000;
      }
      span {
        color: #CBCBCB;
        height: 28px;
        line-height: 28px;
      }

    }
  }

  .logo-img {
    width: 231px;
    display: block;
    margin: 0 auto 20px;
    padding-top: 30px;
  }

  .step-one {
    //padding: 25px 15px 50px;
    padding: 0 0 50px;

    .logo {
      //font-size: 25px;
      font-weight: bold;
      text-align: center;
      margin: 0 14px;
    }
    ::v-deep .mint-field-core {
      height: 22px;
      line-height: 22px;
    }
    ::v-deep .mint-cell {
      height: 22px;
      min-height: 22px;
    }
    .mobile {
      margin: 20px 20px 0;
      .title {
        text-align: center;
        font-weight: bold;
      }

      .value {
        display: flex;
        margin-top: 10px;
        align-items: center;
        border: 2px solid $main_color;
        border-radius: 4px;
        overflow: hidden;

        .prefix {
          min-height: 28px;
          line-height: 28px;
          padding-left: 10px;
        }

        .mint-cell {
          width: 100%;
        }

      }
    }
    .opt {
      margin-top: 20px;
    }
    .login-but {
      width: 169px;
      height: 28px;
      line-height: 28px;
      color: #fff;
      text-align: center;
      font-weight: bold;
      background: #000;
      border-radius: 4px;
      margin: 22px auto 0;
      user-select: none;
    }

    .protocol {
      display: flex;
      word-break: break-all;
      //align-items: baseline;
      margin: 26px 20px 0;
      .iconfont {
        margin-right: 12px;
        color: $main_color;
        font-size: 22px;
        position: relative;
        top: 3px;
      }
      .text {
        background-color: #8D8D8D;
        color: #fff;
        padding: 9px;
        font-size: 12px;
        word-break: break-word;
        span {
          color: #0040fb;
        }
      }
    }
    .send-code-but {
      background-color: $main_color;
      height: 28px;
      line-height: 28px;
      border-radius: 4px;
      color: #fff;
      user-select: none;
      //margin-top: 10px;
      //display: flex;
      //justify-content: center;
      //align-items: center;
      //width: 170px;
      padding: 0 23px;
      margin: 0 auto 0;
      width: min-content;
      white-space: nowrap;
      &.disabled {
        background-color: #eee;
        color: #999;
      }
    }
    .tip {
      margin-top: 20px;
      text-align: center;
      font-weight: bold;
    }
    .opt-number {
      display: flex;
      justify-content: center;
      margin-top: 13px;
    }
  }

  .step-two {
    //padding: 20px 20px 50px;
    padding: 0 0 80px;
    .block {
      background-color: #ECECEC;
      border-radius: 23px;
      padding: 14px 40px 22px;
      margin-left: 5px;
      margin-right: 5px;
      &:nth-child(n+2) {
        margin-top: 24px;
      }
      .field-title {
        font-size: 13px;
        font-weight: bold;
        margin-bottom: 10px;
        &:nth-child(n+2) {
          margin-top: 18px;
        }
        .subtitle {
          font-size: 12px;
          font-weight: initial;
          margin-left: 5px;
        }
      }
      .date-input {
        height: 28px;
        line-height: 28px;
        border-radius: 7px;
        border: 1px solid #E3E3E3;
        background-color: #fff;
        padding: 0 16px;
        font-size: 13px;
        &.default {
          color: #CBCBCB;
        }
      }
      .title {
        font-weight: bold;
        font-size: 13px;
        color: #000000;
      }
      .subtitle {
        font-weight: normal;
        font-size: 13px;
        color: #000000;
        margin-top: 9px;
      }
      .diy-product {
        margin-top: 10px;
      }
    }
    .age {
      display: flex;
      height: 48px;
      align-items: center;
      background-color: #fff;
      padding: 0 10px;

      .title {
        flex-shrink: 0;
      }

      .value {
        flex-grow: 1;
        text-align: right;
        padding-right: 5px;
        height: 28px;
        line-height: 28px;
      }

      .iconfont {
        flex-shrink: 0;
        position: relative;
        top: 1px;
      }

    }
    ::v-deep .mint-cell {
      background-image: none;
      height: 28px;
      line-height: 28px;
      min-height: initial;
      border-radius: 7px;
    }
  }

  .step-three {
    padding-top: 50px;
    .panel {
      margin: 0 30px;
      background-color: #fff;
      border-radius: 8px;
      padding: 30px 30px;
      .iconfont {
        font-size: 40px;
        display: block;
        color: #55A297;
        text-align: center;
      }
      .tip {
        margin-top: 20px;
        text-align: center;
      }
    }
  }

  .but {
    display: block;
    margin: 30px auto 0;
    font-size: 16px;
    background-color: #925b9b;
  }

  .month-popup {
    width: 100%;

    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      height: 40px;
      align-items: center;
    }
  }

  //::v-deep .mint-checklist.is-limit .mint-checkbox-input:checked + .mint-checkbox-core {
  //  background-color: #26a2ff;
  //  border-color: #26a2ff;
  //}
  ::v-deep .mint-checklist {
    .mint-cell {
      background-color: initial;
      height: 20px;
      line-height: 20px;
      &:nth-child(n+2) {
        margin-top: 15px;
      }
      .mint-checklist-label {
        padding: 0;
        .mint-checkbox-label {
          font-weight: bold;
          font-size: 13px;
          color: #000000;
        }
      }
      .mint-cell-wrapper {
        padding: 0;
      }
    }
  }
  ::v-deep .mint-radiolist {
    .mint-cell {
      background-color: initial;
      height: 20px;
      line-height: 20px;
      width: 50%;
      display: inline-block;

      &:nth-child(n+2) {
        margin-top: 15px;
      }
      .mint-radiolist-label {
        padding: 0;
        .mint-radio-label {
          font-weight: bold;
          font-size: 13px;
          color: #000000;
        }
      }
      .mint-cell-wrapper {
        padding: 0;
      }
    }
  }
  .ad {
    margin: 28px 14px 0;
    img {
      width: 100%;
    }
  }
  .submit {
    width: 145px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 7px;
    background-color: $main_color;
    font-weight: bold;
    font-size: 15px;
    color: #FFFFFF;
    margin: 42px auto 0;
    user-select: none;
  }
  .tip-content {
    padding: 27px 17px 28px;
    width: calc(100% - 10px);
    //background-color: #E0E0E0;
    border-radius: 19px;
    .logo {
      width: 126px;
      display: block;
      margin: 0 auto;
    }
    .title {
      margin-top: 21px;
      display: flex;
      img {
        width: 23px;
        height: 23px;
      }
      span {
        flex-grow: 1;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        color: #000000;
      }
    }
    .desc {
      font-weight: bold;
      font-size: 13px;
      color: #000000;
      line-height: 15px;
      text-align: center;
      margin-top: 22px;
    }
    .confirm-but {
      height: 26px;
      line-height: 26px;
      background: $main_color;
      border-radius: 6px;
      margin: 23px auto;
      font-weight: bold;
      font-size: 15px;
      color: #FFFFFF;
      padding: 0 16px;
      width: min-content;
      white-space: nowrap;
    }
  }
  .agree-content {
    width: 96%;
    height: 80%;
    iframe {
      width: 100%;
      height: 100%;
    }
    .confirm-but {
      height: 26px;
      line-height: 26px;
      background: $main_color;
      border-radius: 6px;
      margin: 23px auto;
      font-weight: bold;
      font-size: 15px;
      color: #FFFFFF;
      padding: 0 16px;
      width: min-content;
      white-space: nowrap;
    }
  }
}
</style>
